
type AuditMemoryCookieStatusFields = {
  enhancedMemoryCookieStatuses?: {
    status: string
  }[];
  injectedResult?: {
    template?: {
      status: string;
    };
  };
  memoryCookieStatus?: string;
}

export function getMemoryCookieStatus(audit: AuditMemoryCookieStatusFields): string {
  return (
    audit.enhancedMemoryCookieStatuses?.[0]?.status ||
    audit.injectedResult?.template?.status ||
    audit.memoryCookieStatus ||
    'OTHER'
  )
}
